<template>
  <div v-if="employeeBranchesData" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("employeeName") }}</th>
            <th>{{ $t("branchName") }}</th>
            <th>{{ $t("setting.others.branchRolesMsgs.branchRole") }}</th>
            <th>{{ $t("employeeWorkPlaceType") }}</th>
            <th>{{ $t("info") }}</th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData.usersPrivilegeEmployeeBranches
                    .employeeBranchesUpdate
                )
              "
            >
              {{ $t("edit") }}
            </th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData.usersPrivilegeEmployeeBranches
                    .employeeBranchesArchive
                )
              "
            >
              {{ $t("delete") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(employeeBranch, index) in employeeBranchesData"
            :key="index"
          >
            <td>{{ ++index + pagination.currentIndex }}</td>
            <td>{{ isDataExist(employeeBranch.employeeNameCurrent) }}</td>
            <td>{{ isDataExist(employeeBranch.branchNameCurrent) }}</td>
            <td>{{ isDataExist(employeeBranch.branchRoleNameCurrent) }}</td>
            <td>
              {{ isDataExist(employeeBranch.employeeWorkPlaceTypeNameCurrent) }}
            </td>
            <td>
              <button
                v-b-modal.EmployeeBranchInfo
                class="btn p-0"
                :title="$t('info')"
                @click="setEmployeeBranchData(employeeBranch)"
              >
                <img src="@/assets/images/info.svg" class="icon-lg" />
              </button>
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData.usersPrivilegeEmployeeBranches
                    .employeeBranchesUpdate
                )
              "
            >
              <router-link
                :to="{
                  name: 'EmployeeBranchEditTab',
                  params: {
                    employeeBranchesToken: employeeBranch.employeeBranchesToken,
                  },
                }"
                :title="$t('edit')"
              >
                <img src="@/assets/images/pencil.svg" class="icon-lg" />
              </router-link>
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData.usersPrivilegeEmployeeBranches
                    .employeeBranchesArchive
                )
              "
            >
              <button
                v-b-modal.EmployeeBranchDelete
                class="btn p-0"
                :title="$t('delete')"
                @click="setEmployeeBranchData(employeeBranch)"
              >
                <img src="@/assets/images/trash.svg" class="icon-lg" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { setDataMultiLang, timeToLang, isDataExist } from "@/utils/functions";
import privilegeMixin from "@/utils/privilege-mixin";

export default {
  name: "EmployeeBranchesTable",
  mixins: [privilegeMixin],
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["employeeBranchesData", "pagination"],
  methods: {
    setEmployeeBranchData(employeeBranchData) {
      this.$emit("setEmployeeBranchData", employeeBranchData);
    },
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn, dataUnd) {
      return setDataMultiLang(lang, dataAr, dataEn, dataUnd);
    },
    isDataExist(data) {
      return isDataExist(data);
    },
  },
  computed: {},
};
</script>
